module.exports = __webpack_public_path__ + "static/img/RE9.634653d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE9.jpg
// module id = Ip2J
// module chunks = 0